import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ResetPasswordError } from './reset-password.models';

export const ResetPasswordActions = createActionGroup({
  source: 'Reset Password Page',
  events: {
    'Enter Page': props<{ token: string | null }>(),
    'Leave Page': emptyProps(),
    'Submit Email Request': props<{ email: string }>(),
    'Resend Email': emptyProps(),
    'Submit New Password': props<{ newPassword: string }>(),
    'New Password Changed': props<{ newPassword: string }>(),
    'New Password Check Reset': emptyProps(),
    Retry: emptyProps(),
    'Start New Request': emptyProps(),
    'Resend Cooldown Started': props<{ seconds: number }>(),
    'Resend Cooldown Tick': props<{ remaining: number }>(),
    'Resend Cooldown Finished': emptyProps(),
  },
});

export const ResetPasswordApiActions = createActionGroup({
  source: 'Reset Password API',
  events: {
    'Request Email Success': emptyProps(),
    'Request Email Failure': props<{ error: ResetPasswordError }>(),
    'Resend Email Success': emptyProps(),
    'Resend Email Failure': props<{ error: ResetPasswordError }>(),
    'Verify Token Success': emptyProps(),
    'Verify Token Failure': props<{ error: ResetPasswordError }>(),
    'Update Password Success': emptyProps(),
    'Update Password Failure': props<{ error: ResetPasswordError }>(),
    'Validate New Password Success': props<{ matchesCurrent: boolean }>(),
    'Validate New Password Failure': emptyProps(),
  },
});
